@if (vm.content) {
   <div class="row">
      <div class="col-xs-12">
         <div class="accordion application-form">
            <div class="opener">
               <span class="num last"
                  >1
                  <i class="fa fa-check" aria-hidden="true"></i>
               </span>
               <h1>{{ vm.content.title }} - {{ vm.content.step1Title }}</h1>
               <span [innerHtml]="vm.content.step1Summary"></span>
            </div>
            <div class="slide">
               <form action="#">
                  <fieldset>
                     <legend class="sr-only">{{ vm.content.step1SubTitle }}</legend>
                     <div class="section">
                        <div class="row section__heading">
                           <div class="col-sm-12">
                              <h2>{{ vm.content.step1SubTitle }}</h2>
                           </div>
                        </div>

                        <div class="row">
                           <div class="col-sm-12">
                              <p [innerHtml]="vm.content.step1Body"></p>
                           </div>
                        </div>

                        <div class="row">
                           <div class="col-sm-6">
                              <div class="form-group" [class.has-error]="trn.invalid && trn.touched" [class.has-success]="trn.valid">
                                 <label for="tenancyReference">{{ vm.content.step1TenancyReferenceNumberQuestion }}</label>
                                 <div class="control-label has-feedback">
                                    <input
                                       type="text"
                                       id="tenancyReference"
                                       name="tenancyReference"
                                       #trn="ngModel"
                                       pattern="^[0-9]{4,6}$"
                                       class="form-control"
                                       [(ngModel)]="vm.tenancyReference"
                                       required
                                    />
                                    @if (trn.invalid && trn.touched) {
                                       <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                                    }
                                    @if (trn.valid) {
                                       <i class="fa fa-check-circle-o form-control-feedback" aria-hidden="true"></i>
                                    }
                                 </div>
                                 @if (trn.invalid && trn.touched) {
                                    <span class="help-block">{{ vm.content.step1TenancyReferenceNumberError }}</span>
                                 }
                              </div>
                              <a (click)="showTenancyReferenceInfo()" class="link-info" style="margin-top: 0px; cursor: pointer">
                                 <i class="fa fa-info-circle" aria-hidden="true"></i>
                                 <strong>{{ vm.content.step1TenancyReferenceNumberLinkText }}</strong>
                              </a>
                           </div>
                        </div>

                        <div class="row">
                           <div class="col-sm-6">
                              <div class="form-group" [class.has-error]="postcode.invalid && postcode.touched" [class.has-success]="postcode.valid">
                                 <label class="control-label" for="postcode">{{ vm.content.step1PostcodeQuestion }}</label>
                                 <div class="has-feedback">
                                    <input
                                       type="text"
                                       id="postcode"
                                       name="postcode"
                                       #postcode="ngModel"
                                       maxlength="8"
                                       class="form-control"
                                       [(ngModel)]="vm.postcode"
                                       (input)="formatPostcodeInput($event)"
                                       (blur)="formatPostcodeBlur($event)"
                                       pattern="^[A-Za-z]{1,2}[0-9]{1}[A-Za-z0-9]{0,1}[ ]{0,1}[0-9]{1}[A-Za-z]{2}$"
                                       required
                                    />
                                    @if (postcode.invalid && postcode.touched) {
                                       <i class="fa fa-times-circle-o form-control-feedback" aria-hidden="true"></i>
                                    }
                                    @if (postcode.valid) {
                                       <i class="fa fa-check-circle-o form-control-feedback" aria-hidden="true"></i>
                                    }
                                 </div>
                                 @if (postcode.invalid && postcode.touched) {
                                    <span class="help-block">{{ vm.content.step1PostcodeError }}</span>
                                 }
                              </div>
                           </div>
                        </div>
                     </div>

                     <div class="section">
                        <app-identification-error-summary></app-identification-error-summary>
                        <div class="btn-set clearfix">
                           <button
                              type="button"
                              (click)="findTenancy()"
                              [disabled]="!formComplete() || disableSubmit"
                              id="idvStep1ContinueButton"
                              class="btn btn-primary btn-send"
                           >
                              Continue
                           </button>
                        </div>
                     </div>
                  </fieldset>
               </form>
            </div>
         </div>
      </div>

      <!-- Information Message Modal -->
      <app-modal
         modalId="informationMessageModal"
         [title]="vm.content.step1InformationMessageTitle"
         [config]="{ backdrop: 'static', keyboard: false }"
         size="lg"
         #informationModal
      >
         <div modal-body>
            <div [innerHTML]="vm.content.step1InformationMessageBody"></div>
         </div>
         <div modal-footer>
            <button type="button" class="btn btn-primary" (click)="modalService.close('informationMessageModal')">
               {{ vm.content.step1InformationMessageButton }}
            </button>
         </div>
      </app-modal>

      <!-- Tenancy Reference Question Modal -->
      <app-modal
         modalId="tenancyReferenceQuestionModal"
         [title]="vm.content.step1TenancyReferenceNumberModalTitle"
         [config]="{ backdrop: true, keyboard: true }"
         #tenancyReferenceModal
      >
         <div modal-body>
            <div [innerHTML]="vm.content.step1TenancyReferenceNumberModalBody"></div>
         </div>
         <div modal-footer>
            <button type="button" class="btn btn-primary" (click)="modalService.close('tenancyReferenceQuestionModal')">Close</button>
         </div>
      </app-modal>
   </div>
}
